import {
  SimpleShowLayout,
  Show,
  NumberField,
  TextField,
  FunctionField,
  useTranslate,
} from "react-admin";
import {
  Title,
  ShowOnlyNoEditTopToolbar,
} from "../../shared/components/index.js";
import moment from "moment-timezone";

const QrCardShow = () => {
  const t = useTranslate();

  return (
    <Show
      title={<Title source="name" />}
      actions={<ShowOnlyNoEditTopToolbar />}
    >
      <SimpleShowLayout>
        <TextField source="card_name" />
        <FunctionField
          label="resources.QrCard.source.card_owner"
          source="client_info.owner_client_fn"
          render={(record) => {
            if (record && record.client_info === null) return "";
            if (record && record.client_info?.owner_client_id) {
              return (
                <a
                  style={{ color: "#1976d2", textDecoration: "none" }}
                  href={`/#/CLient/${record.client_info.owner_client_id}/show`}
                >
                  {record.client_info.owner_client_fn}
                </a>
              );
            } else {
              return <TextField source="client_info.owner_client_fn" />;
            }
          }}
        />
        <FunctionField
          label="resources.QrCard.source.card_holder"
          source="client_info.holder_client_fn"
          render={(record) => {
            if (record && record.client_info === null) return "";
            if (record && record.client_info?.holder_client_id) {
              return (
                <a
                  style={{ color: "#1976d2", textDecoration: "none" }}
                  href={`/#/CLient/${record.client_info.holder_client_id}/show`}
                >
                  {record.client_info.holder_client_fn}
                </a>
              );
            } else {
              return <TextField source="client_info.holder_client_fn" />;
            }
          }}
        />
        <FunctionField
          label="resources.QrCard.fields.phone"
          source="client_info.client_phone"
          render={(record) => {
            if (record && record.client_info === null) return "";
            if (record && record.client_info?.holder_client_id) {
              return (
                <a
                  style={{ color: "#1976d2", textDecoration: "none" }}
                  href={`/#/CLient/${record.client_info.holder_client_id}/show`}
                >
                  {record.client_info.client_phone}
                </a>
              );
            } else {
              return <TextField source="client_info.client_phone" />;
            }
          }}
        />
        <NumberField source="balance" />
        <FunctionField
          source="is_archive"
          render={(record) =>
            record && record.is_archive === true
              ? t("resources.QrCard.source.status.archive")
              : t("resources.QrCard.source.status.active")
          }
          label="resources.QrCard.fields.is_archive"
        />
        <FunctionField
          source="begin_date"
          render={(record) =>
            record &&
            moment
              .tz(record.begin_date, "Europe/Kiev")
              .utcOffset(+2)
              .format("DD.MM.YYYY")
          }
          label="resources.QrCard.fields.begin_date"
        />
        <FunctionField
          source="end_date"
          render={(record) =>
            record &&
            moment
              .tz(record.end_date, "Europe/Kiev")
              .utcOffset(+2)
              .format("DD.MM.YYYY")
          }
          label="resources.QrCard.fields.end_date"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default QrCardShow;
